import * as React from 'react';
export const IcStore = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M21.12 5.88l-2.55-2.35A2 2 0 0017.22 3H6.78a2 2 0 00-1.35.53L2.88 5.88a3 3 0 004.24 4.24c.076-.082.146-.169.21-.26a3 3 0 004.67 0 3 3 0 004.67 0c.065.091.135.178.21.26a3 3 0 104.24-4.24zM7.34 12.42a5 5 0 01-4.34.16V18a3 3 0 003 3h5v-8.19a4.91 4.91 0 01-3.66-.39zm9.32 0a4.91 4.91 0 01-3.66.39V15h2a1 1 0 010 2h-2v4h5a3 3 0 003-3v-5.42a5 5 0 01-4.34-.16z'
      fill='currentColor'
    />
  </svg>
);
